import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Scan = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Scan" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M17 2C19.7614 2 22 4.23858 22 7V11H23V13H22V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V13H1V11H2V7C2 4.23858 4.23858 2 7 2H17ZM4 17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V13H4V17ZM7 4C5.34315 4 4 5.34315 4 7V11H20V7L19.9961 6.8457C19.9158 5.26055 18.6051 4 17 4H7Z" fill="#000" />
  </StyledIcon>
));

Scan.displayName = 'Scan';

export { Scan };
